import { render, staticRenderFns } from "./BusinessTravelMainSection.vue?vue&type=template&id=05d77b82"
import script from "./BusinessTravelMainSection.vue?vue&type=script&lang=js"
export * from "./BusinessTravelMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports